/**
 * Componente para mostrar resultados de evaluación con rúbrica
 */

import React from 'react';
import { RubricEvaluation } from '../../services/academicEvaluationService';
import './EvaluationResults.css';

interface EvaluationResultsProps {
  evaluation: RubricEvaluation;
  onClose: () => void;
  onContinue: () => void;
  onRetry?: () => void; // Callback para reintentar cuando score < 70
}

const EvaluationResults: React.FC<EvaluationResultsProps> = ({
  evaluation,
  onClose,
  onContinue,
  onRetry,
}) => {
  const getScoreClass = (score: number): string => {
    if (score >= 90) return 'score-excellent';
    if (score >= 70) return 'score-passing';
    return 'score-failing';
  };

  return (
    <div className="evaluation-results">
      <div className="evaluation-results-header">
        <h2>Resultados de la Evaluación</h2>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
      </div>

      <div className="overall-score">
        <div className={`score-circle ${getScoreClass(evaluation.overall_score)}`}>
          <div className="score-value">{evaluation.overall_score.toFixed(1)}%</div>
          <div className="score-label">Puntuación Total</div>
        </div>
        <div className="score-status">
          {evaluation.overall_score >= 90
            ? '🎉 Excelente'
            : evaluation.overall_score >= 70
            ? '✅ Aprobado'
            : '⚠️ Necesita mejorar'}
        </div>
      </div>

      <div className="elements-breakdown">
        <h3>Desglose por Elemento</h3>
        {evaluation.elements.map((element, index) => (
          <div key={index} className="element-item">
            <div className="element-header">
              <span className="element-name">{element.name}</span>
              <span className={`element-score ${getScoreClass(element.percentage)}`}>
                {element.percentage.toFixed(1)}%
              </span>
            </div>
            <div className="element-feedback">{element.feedback}</div>
            <div className="element-criteria">
              {element.criteria_scores.map((criterion, idx) => (
                <div key={idx} className="criterion-item">
                  <span className="criterion-description">{criterion.description}</span>
                  <span className="criterion-score">
                    {criterion.score.toFixed(1)} / {criterion.max_score}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="evaluation-results-actions">
        {evaluation.overall_score < 70 && onRetry ? (
          <>
            <button className="retry-button" onClick={onRetry}>
              Reintentar Lección
            </button>
            <button className="continue-button secondary" onClick={onContinue}>
              Continuar de Todas Formas
            </button>
          </>
        ) : (
          <button className="continue-button" onClick={onContinue}>
            Continuar
          </button>
        )}
      </div>
    </div>
  );
};

export default EvaluationResults;

